import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import DataTable, { SortOrder } from "react-data-table-component";
import { withTranslation } from "react-i18next";
import { Link, useHistory, withRouter } from "react-router-dom";
import { Form, Input } from "reactstrap";
import { DefaultThemeForReactTable, Loader } from "src/components";
import { getPaginationRequestInitialValue, PaginationRequest } from "src/sdk";
import { Organisation } from "src/sdk/models/Organisation";
import { OrganisationService } from "src/services/OrganisationService";
import Swal from 'sweetalert2';
import { OrganisationsColumns } from "./OrganisationsColumns";


const service = new OrganisationService();

export const Organisations = () => {
  const history = useHistory();

  const [organisationsData, setOrganisationsData] = useState<Organisation[]>([]);
  const [loading, setLoading] = useState(false);
  const [paginationResetDefaultPage, setPaginationResetDefaultPage] = useState(false);
  const [totalRows, setTotalRows] = useState(10000);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState<string>("");
  const [sortBy, setSortBy] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<string>("");

  ////////// SEARCH
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      search: ""
    },
    onSubmit: (values: any) => {
      fetchPage(page, values.search, true, sortBy, sortOrder);
      setSearch(values.search);
    }
  });

  ////////// FETCH PAGINATED DATA
  const fetchPage = async (page: any, search: any, paginationResetDefaultPage: any, sortBy: any, sortOrder: any) => {
    setLoading(true);

    let pagination: PaginationRequest = getPaginationRequestInitialValue();
    pagination.page = page;
    pagination.pageSize = perPage;
    pagination.search = search;
    pagination.sortBy = sortBy;
    pagination.sortOrder = sortOrder;

    getOrganisations(setOrganisationsData, pagination, setTotalRows, setLoading);
    setPaginationResetDefaultPage(paginationResetDefaultPage);
  };

  useEffect(() => {
    fetchPage(page, "", false, sortBy, sortOrder);
  }, []);

  const handlePageChange = (pageNew: any) => {
    fetchPage(pageNew, search, false, sortBy, sortOrder);
  };

  const handlePerRowsChange = async (newPerPage: any, page: any) => {
    setLoading(true);
    let pagination: PaginationRequest = getPaginationRequestInitialValue();
    pagination.page = page;
    pagination.pageSize = newPerPage;
    pagination.search = search;
    pagination.sortBy = sortBy;
    pagination.sortOrder = sortOrder;

    getOrganisations(setOrganisationsData, pagination, setTotalRows, setLoading);
    setPerPage(newPerPage);
  };

  const sortPagination = (state: any, sortDirection: SortOrder) => {
    setSortOrder(sortDirection);
    setSortBy(state.id);
    fetchPage(page, search, false, state.id, sortDirection);
  };

  // Pagination Style
  const paginationComponentOptions = {
    rowsPerPageText: "Rows per page",
    rangeSeparatorText: "of",
    selectAllRowsItem: false,
  };

  ///////////////////////////////
  const fieldsOrganisation = (values: Organisation) => {
    history.push({
      pathname: '/field-setting',
      state: values,
    });
  };

  const usersOrganisation = (values: Organisation) => {
    history.push({
      pathname: '/users-managment',
      state: values as Organisation
    });
  };

  const onEditOrganisation = (values: Organisation) => {
    history.push({
      pathname: '/edit-organisation',
      state: values as Organisation
    });
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div style={{ paddingTop: 10, paddingBottom: 20, display: "flex", flexDirection: "row" }}>
              <Link style={{ color: "black" }} to="/organisations" className="nav_link">
                <h5>Organizations</h5>
              </Link>
              <i className="bi bi-chevron-right"></i>
              <h5 style={{ marginLeft: 13, opacity: 0.6 }}>Organizations List</h5>
            </div>
          </div>
        </div>

        {/* Search & Add Button */}
        <div className="d-flex mb-3">
          <div className="me-auto w-50">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="form-group m-0">
                <div className="input-group">
                  <Input
                    name="search"
                    type="text"
                    className="form-control"
                    placeholder="Search by organization name..."
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.search || ""}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-secondary rounded-0 rounded-end bi bi-search"
                      type="submit"
                    />
                  </div>
                </div>
              </div>
            </Form>
          </div>         
        </div>

        {/* Table */}
        <div style={{ width: "100%" }}>
          <div className="table-responsive">
            <DataTable
              data={organisationsData}
              columns={OrganisationsColumns(fieldsOrganisation, usersOrganisation, onEditOrganisation)}
              customStyles={DefaultThemeForReactTable()}
              progressPending={loading}
              progressComponent={<Loader loading={loading} />}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationResetDefaultPage={paginationResetDefaultPage}
              onChangeRowsPerPage={handlePerRowsChange}
              pointerOnHover={true}
              onChangePage={handlePageChange}
              paginationComponentOptions={paginationComponentOptions}
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
              onSort={sortPagination}
              defaultSortAsc={false}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

Organisations.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(withRouter(Organisations));

// ----------- GET ORGANISATIONS ----------
export const getOrganisations = (
  setOrganisationsData: any,
  pagination: any,
  setTotalRows: any,
  setLoading: any
) => {
  service.getOrganisations(pagination)
    .then(function (response) {
      setTotalRows(response.data.totalRecords);
      setOrganisationsData(response.data.data);
      setLoading(false);
    })
    .catch(function (error) {
      console.log("API ERROR");
      console.log(error);
    });
};
